import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sadieSimulatorTestersQueryKey } from "@/hooks/queries/useGetSadieSimulatorTesters";
import { sadieSimulatorThreadQueryKey } from "@/hooks/queries/useGetSadieSimulatorThread";
import { guacHttpClient } from "@/lib/http";
import { SadieSimulatorStartRequest } from "@/types";

// Starts a tester over in the simulator, or sends their texts back to their
// phone. Starting returns once Sadie's opener is out.
export function useUpdateSetSadieSimulatorRunning() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      change:
        | ({ isRunning: true } & SadieSimulatorStartRequest)
        | { isRunning: false; talentId: number },
    ) => {
      if (change.isRunning) {
        await guacHttpClient.post("relationships/simulator/start", {
          talentId: change.talentId,
          model: change.model,
        });
        return;
      }
      await guacHttpClient.post("relationships/simulator/stop", {
        talentId: change.talentId,
      });
    },
    onSettled: (_data, _error, { talentId }) => {
      void queryClient.invalidateQueries({
        queryKey: sadieSimulatorThreadQueryKey(talentId),
      });
      void queryClient.invalidateQueries({
        queryKey: sadieSimulatorTestersQueryKey,
      });
    },
  });
}
